<ng-container *ngIf="!hasAddresses">
  <div class='empty--container'>
    <a class="link link-underline font-5" (click)="onAddAddressHandler()" title="Add Default Address" href="javascript:void(0)">{{addAddressLabel}} <i class="fas fa-plus"></i></a>
  </div>
</ng-container>
<ng-container *ngIf="hasAddresses">
  <div class="address--scroll--container" #scrollContainer>
    <app-order-list-address-item *ngFor='let address of addresses; index as i;'
                             [address]='address' [showAddButton]="i === addresses.length - 1"
                             [disabled]="disabled"
                             (anotherAddressAdded)="onAddAddressHandler()"
                             (addressUpdated)="onAddressUpdatedHandler($event,i)"
                             (addressRemoved)="onRemoveAddressHandler(i)"></app-order-list-address-item>
  </div>
</ng-container>
